import { css } from 'lit'

export const qrCodeStyles = {
  width: css`var(--cse-qr-code-width, auto)`
}

export const style = css`
  :host {
    display: flex;
    width: ${qrCodeStyles.width};
  }

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`
